<div class="setion scrollbar" id="scrollcustom" *ngIf="data?.type != 'terms'">
  <div class="head">
    <h4>{{ (currentUser.obfuscated && operator.obfuscateName) ? operator.obfuscateName : operator.name }} EULA</h4>
  </div>

  <div class="names">
    <div class="adres">

      <div *ngIf="sanitizedPdfUrl">
        <app-eula-introduction *ngIf="this.currentUser?.obfuscated" [operator] = this.siteUrl></app-eula-introduction>
        <iframe [src]="sanitizedPdfUrl" width="100%" height="100%" seamless="seamless" style="cursor: pointer;" title="eula"></iframe>
      </div>

      <div *ngIf="operator?.operatorKey === OPERATORS.OSK">
        <iframe src="../../../../../assets/files/OSK-EULA.pdf#toolbar=0&navpanes=0&scrollbar=0" width="100%" height="100%"
          seamless="seamless" style="cursor: pointer;" title="eula">
        </iframe>
      </div>
    </div>
  </div>
</div>

<div class="setion scrollbar" id="scrollcustom" *ngIf="data?.type === 'terms'">
  <div class="names">
    <div class="adres">
      <div style="padding-top: 2%;padding-left: 2%;">
        <iframe [src]="safePdfUrl" width="100%" height="100%" seamless="seamless" style="cursor: pointer;" title="terms"></iframe>
      </div>
    </div>
  </div>
</div>


<div class="thanks" *ngIf="data?.type === 'eula'">
  <button mat-flat-button color="primary" class="delete" (keydown)="onKeyPress($event, 1)" (click)="onKeyPress($event, 1)"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Ok, Thanks
  </button>
</div>

<div class="thanks" fxLayoutGap="15px" *ngIf="data?.type === 'save'">
  <button style="border: 1px solid rgba(0,0,0,.12);"
   (keydown)="onKeyPress($event, 1)" (click)="onKeyPress($event, 1)" class="custom-button">
    Close</button>
    <button mat-flat-button color="primary" class="delete" (click)="savePdf(operator?.operatorKey)"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Save
  </button>
</div>

<div class="thanks" fxLayoutGap="15px" *ngIf="data?.type === 'terms'">
  <button style="border: 1px solid rgba(0,0,0,.12);"
   (click)="onNoClick(0)" class="custom-button">
    Decline</button>
    <button mat-flat-button color="primary" class="delete" (click)="onNoClick(1)"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Accept
  </button>
  <button mat-flat-button color="primary" class="delete" (click)="saveTermPdf()"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Save
  </button>
</div>